import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { AccessTokenValidationReq, AuthTokenReq_KYC, JWTTokenReq } from '../models/request.model';
import { APICallingLimit, SessionStorage } from './constant.service';
import { handleHttpError } from './handle-http-error.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private http: HttpClient,private sessionStorageService: SessionStorageService) { }

  generateToken_KYC(appSource: string): Observable<any> {
    const headers = new HttpHeaders({
    Authorization: environment.auth_generate_key,
  });

    const params = new HttpParams().set('appSource', appSource);
    return this.http
      .get<any>(environment.kyc_Url + 'auth/generate/key', {
        headers,
        params,
      })
      .pipe(
        retry(APICallingLimit.zero_0), // Simple retry logic with a fixed number of retries
        catchError(handleHttpError)
      );
  }

  auth_Token_KYC(authTokenReq_KYC: AuthTokenReq_KYC): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.microChartHeaderKey,
      authorization:
        this.sessionStorageService.getItem(SessionStorage.authorization_KYC) ||
        '',
      appSource: authTokenReq_KYC.appSource,
    });
    return this.http
      .post<any>(environment.kyc_Url + 'auth/token', authTokenReq_KYC, {
        headers,
      })
      .pipe(
        retry(APICallingLimit.zero_0), // Simple retry logic with a fixed number of retries
        catchError(handleHttpError)
      );
  }

  JWTToken(
    JWTTokenReq: JWTTokenReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
      ReqSource: JWTTokenReq.head.AppSource,      
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'JWTToken',
        JWTTokenReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  accessTokenValidation(
    AccessTokenValidationReq: AccessTokenValidationReq
  ): Observable<any> {
    let apiheaders = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.eaccount_GatewayKey,
    });
    let header = { headers: apiheaders, withCredentials: true };
    return this.http
      .post(
        environment.diygateway_url + 'access-token-validation',
        AccessTokenValidationReq,
        header
      )
      .pipe(
        retry(APICallingLimit.one_1), // Simple retry logic with a fixed number of retries
        catchError(handleHttpError)
      );
  }

  checkLoginResponse(): Observable<any> {
    const reqBody = {
      head: {
        appName: '5PTRADE',
        appSource: '21',
        appVer: '1.0',
        key: '',
        osName: 'Web',
        requestCode: '5PCLRes',
      },
      body: {},
    };
    let tradeApiheaders = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.tradeapi_GatewayKey,
    });
    let options = { headers: tradeApiheaders , withCredentials: true };
    return this.http
      .post(environment.tradeapi_url + 'CheckLoginResponse', reqBody, options)
      .pipe(
        retry(APICallingLimit.one_1), // Simple retry logic with a fixed number of retries
        catchError(handleHttpError)
      );
  }

}
